import EmergencyActionPlan from './EmergencyActionPlan'
export default EmergencyActionPlan